import { usePage, router } from "@inertiajs/react";
import AppLayout from "@/layout/AppLayout";
import { Star, Gamepad2 } from "lucide-react";

export default function EventWantToPlaysIndex() {
  const { event, attendee_libraries, my_want_to_plays, my_want_to_play_ids, paths } = usePage().props;

  const wantSet = new Set(my_want_to_play_ids || []);
  // map bgg_id → record id for deletes
  const wantMap = {};
  (my_want_to_plays || []).forEach((w) => { wantMap[w.bgg_id] = w.id; });

  function toggle(game) {
    if (wantSet.has(game.bgg_id)) {
      const id = wantMap[game.bgg_id];
      if (id) router.delete(`${paths.want_to_plays}/${id}`);
    } else {
      router.post(paths.want_to_plays, { bgg_game_id: game.bgg_id });
    }
  }

  return (
    <AppLayout>
      <div className="container py-8 max-w-3xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Want to Play</h1>
          <p className="text-sm text-muted-foreground">{event.title}</p>
        </div>

        {attendee_libraries.length === 0 ? (
          <div className="text-center py-12 text-muted-foreground">
            <Gamepad2 className="h-8 w-8 mx-auto mb-2 opacity-40" />
            <p className="text-sm">No one has synced their game library yet.</p>
          </div>
        ) : (
          <div className="space-y-8">
            {attendee_libraries.map((lib) => (
              <AttendeeSection
                key={lib.user.id}
                lib={lib}
                wantSet={wantSet}
                onToggle={toggle}
              />
            ))}
          </div>
        )}
      </div>
    </AppLayout>
  );
}

function AttendeeSection({ lib, wantSet, onToggle }) {
  return (
    <div>
      <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-3">
        {lib.user.full_name}&apos;s Games
      </h2>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
        {lib.games.map((game) => (
          <GameCard
            key={game.bgg_id}
            game={game}
            wanting={wantSet.has(game.bgg_id)}
            onToggle={() => onToggle(game)}
          />
        ))}
      </div>
    </div>
  );
}

function GameCard({ game, wanting, onToggle }) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="aspect-[2/3] rounded-lg overflow-hidden bg-muted">
        {game.thumbnail_url ? (
          <img
            src={game.thumbnail_url}
            alt={game.title}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-200"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Gamepad2 className="h-5 w-5 text-muted-foreground/40" />
          </div>
        )}
      </div>
      <p className="text-xs font-medium truncate" title={game.title}>{game.title}</p>
      <button
        onClick={onToggle}
        className={`w-full py-1.5 rounded text-[10px] font-medium flex items-center justify-center gap-1 transition-all
          ${wanting
            ? "bg-primary/15 text-primary ring-1 ring-primary/30"
            : "bg-muted/60 text-muted-foreground hover:bg-muted hover:text-foreground"}`}
      >
        <Star className="h-2.5 w-2.5 shrink-0" />
        {wanting ? "Want ✓" : "Want to play"}
      </button>
    </div>
  );
}
